import React, { useState } from 'react'

import jsPDF from 'jspdf';
import html2canvas from "html2canvas";

import SvgIcon from '../../CustomeComponents/SvgIcon';
import { PanelBar, PanelBarUtils } from '@progress/kendo-react-layout';

let dataItems = [];
const flatData = (data) => {
  if (data.length > 0) {
    for (let i = 0; i < data.length; i++) {
      dataItems.push(data[i].id);
    }
    return dataItems;
  }
}

// const ProcessInfo = ({ PanelBarItemsExt, expanded, onExpendAll }) => {
const ProcessInfo = ({ PanelBarItemsExt, systemCode, isMobile }) => {
  const components = PanelBarUtils.mapItemsToComponents(PanelBarItemsExt);
  const [expanded, setExpanded] = useState([`.${PanelBarItemsExt.length - 1}`]);
  const [isControlledOpen, setIsControlledOpen] = useState(false);

  const handleExpand = () => {
    setIsControlledOpen(true);
    const flattenItemsIds = flatData(PanelBarItemsExt);
    setExpanded(flattenItemsIds); // expanded = [".0", ".1", ".2", ".3", ".4", ".5", ".6", ".7"];
    dataItems = [];
  };

  const exportPDF_NG = () => {
    handleExpand();
    
    setTimeout(() => {
      // 1. Save Title as pdf
      const tikDataTitle = document.getElementById("tikToPrint");
      const pdf = new jsPDF("p", "mm");

      html2canvas(tikDataTitle).then((canvasTitle) => {
        const imgWidth = 190;
        const imgHeight = (canvasTitle.height * imgWidth) / canvasTitle.width;
        let positionY = 10;
        pdf.addImage(canvasTitle, "PNG", 10, positionY, imgWidth, imgHeight, "", "FAST");
      });
      
      //2. Save the table as pdf
      const tableData = document.getElementById("dataToPrint");
      html2canvas(tableData).then((canvasTable) => {
        const imgWidth = 200; //180
        const pageHeight = 295;
        const imgHeight = (canvasTable.height * imgWidth) / canvasTable.width;
        let heightLeft = imgHeight;
        let positionY = 10;
        heightLeft -= pageHeight;

        pdf.addImage(canvasTable, "PNG", 0, positionY + 10, imgWidth, imgHeight, "", "FAST");
        while (heightLeft >= 0) {
          positionY = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(canvasTable, "PNG", 0, positionY + 20, imgWidth, imgHeight, "", "FAST");
          heightLeft -= pageHeight;
        }
        
        pdf.save(`תהליך טיפול`);
      });
    }, 1000);
  }

  return (
    <div className="container my-3 my-lg-5" id="dataToPrint" style={{ marginTop: "50px" }}>  
        {
          (systemCode === "26400046" || systemCode === "26400001") && isMobile ?
            ""
            :
            <span>
                <SvgIcon icon={"download-doc"} title="ייצוא ל- PDF" onClick={() => exportPDF_NG()} style={{ cursor: "pointer", marginLeft: "5px" }} /> 
                ייצוא ל- PDF
            </span>
        }
        <PanelBar 
          expandMode="multiple" 
          children={components} 
          isControlled={isControlledOpen}
          expanded={expanded}
          onSelect={() => setIsControlledOpen(false)}
        />
    </div>
  )
}

export default ProcessInfo;